'use client';

import { styled } from '@material-ui/core/styles';
import React from 'react';

const Wrapper = styled('div')({
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const Loading = () => (
  <Wrapper>
    <h1>Loading</h1>
  </Wrapper>
);

export default Loading;
